<div class="mt-4 space-y-4">
    <!-- ส่วนของฟอร์มค้นหา -->
    <div class="card">
        <form [formGroup]="form" class="grid grid-cols-2 md:grid-cols-3 2xl:grid-cols-5 gap-4">
            <!-- ช่วงเวลาข้อมูล -->
            <div class="w-full col-span-full">
                <label class="text-sm">ช่วงเวลาข้อมูล</label>
                <app-select-date-option [selectedOption]="selectedDate"
                    (selectOption)="handleOptionSelected($event)"></app-select-date-option>
            </div>
            <!-- กลุ่มช่องทางการขาย -->
            <div class="w-full">
                <label class="text-sm whitespace-nowrap w-full">กลุ่มช่องการทางขาย</label>
                <div class="w-full">
                    <mat-form-field class="w-full">
                        <mat-select multiple [value]="displayedPlatformGroupSelection"
                            (selectionChange)="onPlatformGroupSelectionChange($event.value)"
                            placeholder="เลือกกลุ่มช่องทางการขาย">
                            <mat-option [value]="ALL_GROUP_MARKER">เลือกทั้งหมด</mat-option>
                            @for (channel of platformGroup; track channel.id) {
                            <mat-option [value]="channel.id">{{channel.name}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <!-- หมวดสินค้าสินค้า -->
            <div class="w-full">
                <label class="text-sm">หมวดหมู่</label>
                <mat-form-field class="w-full">
                    <mat-select class="" placeholder="เลือกหมวดหมู่" formControlName="category_id">
                        <mat-option value="">ทั้งหมด</mat-option>
                        @for (item of categories; track $index) {
                        <mat-option [value]="item.id">{{item.name}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- tag สินค้า -->
            <div class="w-full">
                <label class="text-sm whitespace-nowrap w-full">Tags</label>
                <div class="w-full">
                    <mat-form-field class="w-full">
                        <mat-select multiple [value]="displayedTagSelection"
                            (selectionChange)="onTagSelectionChange($event.value)" placeholder="เลือก tag">
                            <mat-option [value]="ALL_TAG_MARKER">เลือกทั้งหมด</mat-option>
                            @for (tag of tags; track tag) {
                            <mat-option [value]="tag">{{tag}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <!-- ค้นหาสินค้า -->
            <div class="w-full">
                <label class="text-sm">สินค้า</label>
                <div class="flex gap-2 w-full relative">
                    <input #product type="text" class="input" placeholder="SKU, ชื่อสินค้า" [(ngModel)]="keyword"
                        [ngModelOptions]="{standalone: true}" (ngModelChange)="productSearch()">

                    <!-- รายการสินค้าที่ค้นหาเจอ -->
                    @if (showProductFilter) {
                    <ul
                        class="absolute z-50 w-96 !rounded-lg bg-white mat-elevation-z8 max-h-72 overflow-y-auto top-11 py-2">
                        @for (product of productsFilter; track product.sku) {
                        <li class="min-h-[48px] whitespace-nowrap hover:bg-secondary-100 hover:cursor-pointer flex items-center p-2 text-sm"
                            (click)="selectProduct(product)">
                            <img [src]="'https://storage.maxxgadget.com/img/product/' + product.sku + '/1.jpg'" alt=""
                                class="flex-none h-11 w-11 mr-2"
                                onerror="this.onerror=null; this.src='assets/images/warranty.png'">
                            <div class="w-full flex flex-col truncate">
                                <span class="pr-2 text-blue-500">{{ product.sku }} :</span>
                                <span class="w-full truncate whitespace-nowrap">{{ product.name }}</span>
                            </div>
                        </li>
                        }
                    </ul>
                    }

                    <!-- ปุ่มล้างการค้นหา -->
                    @if (keyword.length > 0) {
                    <div class="absolute flex justify-center flex-col right-2 top-1">
                        <button type="button" (click)="clearSearch()">
                            <fa-icon [icon]="faXmark" class="text-secondary-900"></fa-icon>
                        </button>
                    </div>
                    }
                </div>
            </div>

            <!-- ปุ่มค้นหา -->
            <button type="button" class="btn-sm btn-primary w-fit self-end" (click)="submitForm()">ค้นหา</button>
        </form>

        <!-- แสดงตัวกรองที่เลือก -->
        <div class="mt-4 w-full bg-gray-100 rounded-lg p-4 text-sm">
            <!-- กลุ่มช่องทางการขายที่เลือก -->
            <div class="flex gap-4 mt-2">
                <div class="whitespace-nowrap text-gray-500">กลุ่มช่องทางการขาย : </div>
                @if (selectedPlatfromGroup.length > 0) {
                <div class="w-full flex flex-row gap-1 flex-wrap">
                    @for (item of displayPlatfromGroup(); track item.id) {
                    <div class="label label-secondary w-fit !text-xs text-nowrap">
                        {{item.name}}
                        <span class="cursor-pointer ml-3" (click)="removePlatfromGroupSelected(item)">&#x2715;</span>
                    </div>
                    }
                    @if (selectedPlatfromGroup.length > 1) {
                    <button class="label label-light w-fit !text-xs text-nowrap border" type="button"
                        (click)="removePlatfromGroupSelectedAll()">ลบทั้งหมด</button>
                    }
                </div>
                } @else {
                ทั้งหมด
                }
            </div>

            <!-- สินค้าที่เลือก -->
            <div class="flex gap-4 mt-2">
                <div class="whitespace-nowrap text-gray-500">สินค้าที่เลือก : </div>
                @if (productSelected.length > 0) {
                <div class="w-full flex flex-row gap-1 flex-wrap">
                    @for (item of productSelected; track item.sku) {
                    <div class="label label-primary w-fit !text-xs text-nowrap">
                        {{item.name}}
                        <span class="cursor-pointer ml-3" (click)="removeProductSelected(item)">&#x2715;</span>
                    </div>
                    }
                    @if (productSelected.length > 1) {
                    <button class="label label-light w-fit !text-xs text-nowrap border" type="button"
                        (click)="removeProductSelectedAll()">ลบทั้งหมด</button>
                    }
                </div>
                } @else {
                ทั้งหมด
                }
            </div>
        </div>
    </div>

    <!-- แสดงการโหลดข้อมูล -->
    @if (loading) {
    <div class="card">
        <div class="flex flex-col items-center py-6 space-y-3">
            <app-loader></app-loader>
            <div class="font-medium">กำลังโหลดข้อมูล</div>
        </div>
    </div>
    }

    <!-- กรณีไม่พบข้อมูล -->
    @if (!loading && tableDatasets.length === 0) {
    <div class="card">
        <div class="flex flex-col items-center py-6 space-y-3">
            <div class="h-32">
                <img src="assets/images/web_20.png" alt="" class="h-full">
            </div>
            <div class="font-medium">ไม่พบข้อมูล</div>
        </div>
    </div>
    }

    <!-- แสดงข้อมูลในตาราง -->
    @if (!loading && tableDatasets.length > 0) {
    <div class="grid grid-cols-1">
        <div class="card">
            <div class="w-full">
                <div class="flex space-x-2 items-center justify-between">
                    <div class="font-medium">
                        TOP สินค้าขายดี
                    </div>
                    <div class="flex space-x-2 items-center">
                        <div class="text-sm">การแสดงผล : </div>
                        <mat-form-field class="w-fit !h-9 !text-sm">
                            <mat-select class="!h-9" [value]="displayData"
                                (selectionChange)="displayDataOnchange($event)">
                                <mat-option class="!text-sm" value="total_amount">มูลค่า</mat-option>
                                <mat-option class="!text-sm" value="total_qty">จำนวนชิ้น</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <!-- ส่วนกราฟ -->
            <div class="mt-4 flex flex-wrap items-start gap-4">
                <div class="flex-1 min-w-0">
                    <app-group-bar-chart [chartId]="'purchaseProductOverviewChart'" [datasets]="chartDataset"
                        [orientation]="'horizontal'" [showLegend]="false" [scheme]="chartScheme"
                        [xAxisLabel]="displayData === 'total_qty' ? 'จำนวนชิ้น' : 'มูลค่า (บาท)'"
                        [height]="(chartDataset.length * 90 + 60) + 'px'">
                    </app-group-bar-chart>
                </div>
                <div class="w-48 shrink-0 pt-4">
                    <div class="text-sm font-medium text-gray-500 mb-2">กลุ่มช่องทางการขาย</div>
                    <div class="flex flex-col gap-1">
                        @for (group of chartGroups; track group.id) {
                        <button type="button" class="flex items-center gap-2 text-left text-sm px-2 py-1 rounded hover:bg-gray-100 transition-colors"
                            [ngClass]="hiddenGroups.has(group.id) ? 'opacity-40' : ''"
                            [title]="groupShopsLabel(group.id)"
                            (click)="togglePlatformGroupVisibility(group.id)">
                            <span class="inline-block w-3 h-3 rounded-full shrink-0"
                                [style.background-color]="groupColor($index)"
                                [ngClass]="hiddenGroups.has(group.id) ? 'opacity-50' : ''"></span>
                            <span class="truncate" [ngClass]="hiddenGroups.has(group.id) ? 'line-through' : ''">
                                {{group.name}}
                            </span>
                        </button>
                        }
                    </div>
                </div>
            </div>

            <!-- ตาราง -->
            <div class="mt-4">
                <div class="div-table">
                    <div class="relative w-full h-[600px]">
                        <div class="w-full h-full overflow-auto">
                            <table class="min-w-full border-separate border-spacing-0">
                                <thead>
                                    <tr class="thead-tr">
                                        <!-- คอลัมน์ที่ตรึงไว้ (sticky) -->
                                        <th
                                            class="sticky left-0 top-0 z-20 bg-gray-100 border-r border-gray-200 text-left shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)]">
                                            สินค้า
                                        </th>
                                        <!-- คอลัมน์ที่เหลือ -->
                                        <th class="sticky top-0 z-10 bg-gray-100 text-center border-b border-gray-200">
                                            สต๊อก
                                        </th>
                                        @for (item of platformGroupFiltered; track item.id) {
                                        <th class="sticky top-0 z-10 bg-gray-100 text-right border-b border-gray-200">
                                            <button type="button"
                                                class="w-full text-right flex flex-row space-x-1 items-center justify-end"
                                                (click)="sortByPlatformGroup(item.id)">
                                                <div class="">{{item.name}}</div>
                                                <div class="gap-0">
                                                    @if (selectedSortPlatfromGroup === item.id && sortBy) {
                                                    @if (sortBy === 'min') {
                                                    <fa-icon [icon]="faCaretUp" class="text-primary-500"></fa-icon>
                                                    } @else if (sortBy === 'max') {
                                                    <fa-icon [icon]="faCaretDown" class="text-primary-500"></fa-icon>
                                                    }
                                                    } @else {
                                                    <fa-icon [icon]="faSort" class="text-gray-400"></fa-icon>
                                                    }
                                                </div>
                                            </button>
                                        </th>
                                        }
                                        <th class="sticky top-0 z-10 bg-gray-100 text-right border-b border-gray-200">
                                            <button type="button"
                                                class="w-full text-right flex flex-row space-x-1 items-center justify-end"
                                                (click)="sortData('')">
                                                <div class="">รวม</div>
                                                <div class="gap-0">
                                                    @if (selectedSortFiled === '' && sortBy &&
                                                    !selectedSortPlatfromGroup) {
                                                    @if (sortBy === 'min') {
                                                    <fa-icon [icon]="faCaretUp" class="text-primary-500"></fa-icon>
                                                    } @else if (sortBy === 'max') {
                                                    <fa-icon [icon]="faCaretDown" class="text-primary-500"></fa-icon>
                                                    }
                                                    } @else {
                                                    <fa-icon [icon]="faSort" class="text-gray-400"></fa-icon>
                                                    }
                                                </div>
                                            </button>
                                        </th>
                                        <th class="sticky top-0 z-10 bg-gray-100 text-right border-b border-gray-200">
                                            <button type="button"
                                                class="w-full text-right flex flex-row space-x-1 items-center justify-end"
                                                (click)="sortData('avg_qty_per_day')">
                                                <div class="">จำนวน<br>เฉลี่ย/วัน</div>
                                                <div class="gap-0">
                                                    @if (selectedSortFiled === 'avg_qty_per_day' && sortBy) {
                                                    @if (sortBy === 'min') {
                                                    <fa-icon [icon]="faCaretUp" class="text-primary-500"></fa-icon>
                                                    } @else if (sortBy === 'max') {
                                                    <fa-icon [icon]="faCaretDown" class="text-primary-500"></fa-icon>
                                                    }
                                                    } @else {
                                                    <fa-icon [icon]="faSort" class="text-gray-400"></fa-icon>
                                                    }
                                                </div>
                                            </button>
                                        </th>
                                        <th class="sticky top-0 z-10 bg-gray-100 text-right border-b border-gray-200">
                                            <div class="whitespace-nowrap">จำนวนวัน<br>ที่จะขายได้</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (row of tableDatasets; track row.sku) {
                                    <tr class="tbody-tr"
                                        [ngClass]="row.name === TOTAL_ROW_NAME ? 'bg-primary-50 font-bold border-t-2 border-primary-300' : 'hover:bg-gray-50'">
                                        <!-- คอลัมน์ที่ตรึงไว้ (sticky) -->
                                        <td
                                            class="min-w-[25rem] sticky left-0 z-10 border-r border-gray-200 border-b border-solid shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)]"
                                            [ngClass]="row.name === TOTAL_ROW_NAME ? 'bg-primary-50' : 'bg-white hover:bg-gray-50'">
                                            <div class="flex items-center gap-2">
                                                @if (row.sku) {
                                                <img [src]="'https://storage.maxxgadget.com/img/product/' + row.sku + '/1.jpg'"
                                                    alt="" class="w-8 h-8"
                                                    onerror="this.onerror=null; this.src='assets/images/warranty.png'">
                                                }
                                                <div class="flex-1 w-0">
                                                    @if (row.name === TOTAL_ROW_NAME) {
                                                    <div class="truncate max-w-[20rem] md:max-w-max">
                                                        {{ row.name }}
                                                    </div>
                                                    } @else {
                                                    <div class="truncate cursor-pointer hover:text-primary-500 max-w-[20rem] md:max-w-max"
                                                        (click)="selectedRowOnChange(row)">
                                                        {{ row.name }}
                                                    </div>
                                                    }
                                                    @if (row.name !== TOTAL_ROW_NAME) {
                                                    <div class="flex gap-1 flex-wrap">
                                                        @for (tag of tags; track tag) {
                                                        <button
                                                            [ngClass]="{'bg-amber-500': tagIncludes(tag, row.sku),'bg-gray-300':  !tagIncludes(tag, row.sku)}"
                                                            class="text-white space-x-2 pl-2.5 pr-2 font-light text-xs rounded-lg hover:"
                                                            (click)="addTag(row.sku, tag)">
                                                            {{tag}}
                                                        </button>
                                                        }
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                        </td>
                                        <!-- คอลัมน์ที่เหลือ -->
                                        <td class="w-24 border-b border-gray-200 border-solid font-semibold">
                                            <div [ngClass]="{'text-lime-500': row.stock > 0, 'text-red-600': row.stock <= 0}"
                                                class="text-center">{{row.stock | number}}</div>
                                        </td>

                                        @for (item of row.groups; track $index) {
                                        <td class="w-24 border-b border-gray-200 border-solid">
                                            <div class="text-right w-full">
                                                @if (displayData === 'total_qty') {
                                                {{item.total_qty | number}}
                                                } @else {
                                                {{item.total_amount | number}}
                                                }
                                            </div>
                                        </td>
                                        }
                                        <td class="w-28 border-b border-gray-200 border-solid">
                                            <div class="w-full text-right text-primary-500 font-semibold">
                                                @if (displayData === 'total_qty') {
                                                {{row.total_qty| number}}
                                                } @else {
                                                {{row.total_amount| number}}
                                                }
                                            </div>
                                        </td>
                                        <td class="w-28 border-b border-gray-200 border-solid">
                                            <div class="w-full text-right" *ngIf="row.name !== TOTAL_ROW_NAME">
                                                @if (displayData === 'total_qty') {
                                                {{row.avg_qty_per_day| number}}
                                                } @else {
                                                {{row.avg_amount_per_day| number}}
                                                }
                                            </div>
                                        </td>
                                        <td class="w-28 text-right border-b border-gray-200 border-solid font-semibold"
                                            [ngClass]="row.name === TOTAL_ROW_NAME ? '' : {'text-primary-500': row.sale_in_day > 0, 'text-red-600': row.sale_in_day <= 3}">
                                            <div *ngIf="row.name !== TOTAL_ROW_NAME">
                                                {{row.sale_in_day | number}}
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- แสดงกราฟเมื่อคลิกที่แถว -->
                                    <tr>
                                        <td colspan="100"
                                            class="transition-all ease-in-out duration-500 relative overflow-hidden border-b border-gray-200 border-solid"
                                            [ngClass]="{ 'max-h-96 opacity-100': row.sku && selectedRow === row.sku, 'max-h-0 opacity-0 hidden': !row.sku || selectedRow !== row.sku }">
                                            <div class="px-4 py-8">
                                                @if (chartLoaded && performanceDatasets.length > 0) {
                                                <div class="text-center font-medium py-2">{{performanceChartLabel}}</div>
                                                <div class="h-48">
                                                    <app-line-chart [chartId]="'chart-performance-'+row.sku"
                                                        [legendPosition]="legendPosition"
                                                        [datasets]="performanceDatasets"></app-line-chart>
                                                </div>
                                                } @else if (chartLoaded && performanceDatasets.length === 0) {
                                                <div
                                                    class="h-48 w-full flex items-center justify-center bg-gray-100 rounded-lg">
                                                    <div class="">ไม่พบข้อมูล</div>
                                                </div>
                                                } @else {
                                                <div
                                                    class="h-48 w-full flex items-center justify-center bg-gray-100 rounded-lg">
                                                    <app-loader></app-loader>
                                                </div>
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
</div>